import { useStaticQuery, graphql } from "gatsby"
import { IArticle } from "../../gatsby-graphql"

export interface GetArticlesParams {
  count?: number
  locale?: string | null
  categorySlug?: string | null
}

export const getArticles = ({
  count = 30,
  locale = null,
  categorySlug = null,
}: GetArticlesParams): IArticle[] => {
  // query all articles, since parameters in static queries are not available
  let { articles } = useStaticQuery(graphql`
    query ArticlesQuery {
      articles: allStrapiArticle(sort: { fields: published_at, order: DESC }) {
        nodes {
          ...FArticle
        }
      }
    }
  `)

  const filterArticles = (article: IArticle) => {
    if (locale && locale !== article.locale) {
      return false
    }
    if (categorySlug && categorySlug !== article.category?.slug) {
      return false
    }

    return true
  }

  return articles.nodes.filter(filterArticles).slice(0, count || 30)
}
